export default {"src":"/_next/static/media/Logo_Horizontal_Dark.dec129f8.svg","height":48,"width":265};